import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconAccelTuneup = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={21}
    fill="none"
    viewBox="0 0 24 21"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-accel-tuneup_svg__a)"
      d="M12 1.75c6.21 0 11.25 5.04 11.25 11.25 0 2.07-.586 4.023-1.523 5.664-.235.39-.665.625-1.094.625H3.328c-.43 0-.86-.234-1.055-.625C1.297 17.024.75 15.07.75 13 .75 6.79 5.79 1.75 12 1.75Zm5.625 5c-.703 0-1.25.586-1.25 1.25 0 .703.547 1.25 1.25 1.25.664 0 1.25-.547 1.25-1.25 0-.664-.586-1.25-1.25-1.25ZM12 4.25c-.703 0-1.25.586-1.25 1.25 0 .703.547 1.25 1.25 1.25.664 0 1.25-.547 1.25-1.25 0-.664-.586-1.25-1.25-1.25ZM4.5 15.5c.664 0 1.25-.547 1.25-1.25 0-.664-.586-1.25-1.25-1.25-.703 0-1.25.586-1.25 1.25 0 .703.547 1.25 1.25 1.25Zm1.875-6.25c.664 0 1.25-.547 1.25-1.25 0-.664-.586-1.25-1.25-1.25-.703 0-1.25.586-1.25 1.25 0 .703.547 1.25 1.25 1.25Zm13.281 5.938c.508-.079.82-.547.742-1.055a.926.926 0 0 0-1.054-.781l-5.235.859C13.68 13.508 12.9 13 12 13a2.492 2.492 0 0 0-2.5 2.5c0 .469.117.898.313 1.25h4.335c.118-.195.196-.43.274-.703l5.234-.86Z"
    />
    <defs>
      <linearGradient
        id="icon-accel-tuneup_svg__a"
        x1={22}
        x2={3.025}
        y1={1}
        y2={20.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCF4BF" />
        <stop offset={0.18} stopColor="#EFC862" />
        <stop offset={0.73} stopColor="#CD9832" />
        <stop offset={1} stopColor="#BB811B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconAccelTuneup;
